import axios  from "axios";
import {IUtmFull} from "../models/utm.interface";

export const utmService = {
    getUtmSecureCookieValues: async (): Promise<IUtmFull> => {
        return new Promise((resolve, reject) => {
            axios.get<{ utm: IUtmFull }>(`/utm`, {withCredentials: true}).then((response) => {
                resolve(response.data.utm as IUtmFull);                
            }
            , (err) => {
                reject(err);
            });                         
        });
        
    }
};
